import React, {useEffect,useState} from 'react'
import BridgecrewMappingForm from './BridgecrewMappingForm';
import BridgecrewCredentialsForm from './BridgecrewCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';

export default function BridgecrewConfigListing(props) {

    const [loginConfig,setLoginConfig] = useState([]);

    useEffect(()=>{
        if(props.loginConfigList && props.loginConfigList.length){
            let value = props.loginConfigList.map((login)=> {
                const {username, ...restConfig} = login;
                return { 
                   ...restConfig,
                   accessKey: username
                }
            })
        setLoginConfig(value);
        } else {
            setLoginConfig([])
        }
    },[props.loginConfigList])


    return (
        <GenericPullConfigListing
            {...props}
            loginConfigList={loginConfig}
            toolName={props.name}
            MappingForm={BridgecrewMappingForm}
            CredentialsForm={BridgecrewCredentialsForm}
            componentName="Account"
            componentKey="accountName"
        />
    )
}